/**
 * Login Page
 * Full page component for user login
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiShield, FiArrowRight } from 'react-icons/fi';
import { LoginForm } from '../components/auth/LoginForm';
import SEO from '../components/common/SEO';

const LoginPage: React.FC = () => {
  return (
    <>
      <SEO
        title="เข้าสู่ระบบ | Thai Security Directory"
        description="เข้าสู่ระบบเพื่อจัดการข้อมูลบริษัทและเข้าถึงฟีเจอร์เพิ่มเติม"
        url="/login"
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col justify-center py-12 sm:px-6 lg:px-8"
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              เข้าสู่ระบบ
            </h1>
            <p className="text-sm text-gray-600">
              เข้าสู่ระบบเพื่อจัดการข้อมูลบริษัทและเข้าถึงฟีเจอร์เพิ่มเติม
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <LoginForm />
        </div>

        {/* Information Notice */}
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start">
              <FiShield className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="ml-3">
                <p className="text-sm font-medium text-blue-900 mb-1">
                  สำหรับทุกผู้ใช้งาน
                </p>
                <p className="text-xs text-blue-700">
                  ใช้หน้าเข้าสู่ระบบเดียวกันสำหรับสมาชิก และผู้ดูแลระบบ
                  <br />
                  ระบบจะนำทางไปยังหน้าที่เหมาะสมตามสิทธิ์ของคุณโดยอัตโนมัติ
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default LoginPage;